import React from "react";
import styled, { keyframes } from "styled-components";
import { FaQuoteLeft } from "react-icons/fa";

const testimonialsData = [
  {
    quote: "Circuitech delivered exceptional power quality solutions that improved our facility's efficiency significantly.",
    name: "Fatima Al Mansouri",
    role: "Operations Manager, Emirates Industrial Panel",
  },
  {
    quote: "Their engineering team truly understands the needs of UAE's commercial infrastructure. Highly recommended!",
    name: "Ahmed Bin Khalid",
    role: "Technical Director, Al Noor Energy",
  },
  {
    quote: "Their quick response and customized solutions made a huge difference in our data center operations.",
    name: "Ranya El Said",
    role: "IT Manager, Dubai Data Systems",
  },
  {
    quote: "We faced serious harmonic issues until Circuitech stepped in with their expertise. Outstanding service.",
    name: "Omar Al Hashimi",
    role: "Facility Engineer, Dubai Silicon Oasis Authority",
  },
  {
    quote: "Their team’s commitment to quality and uptime made them an integral part of our power infrastructure project.",
    name: "Laila Hassan",
    role: "Project Lead, Sharjah Sustainable City",
  },
  {
    quote: "Circuitech’s ability to adapt to our fast-paced construction timelines is unmatched in the region.",
    name: "Mohammed Al Suwaidi",
    role: "Site Manager, ADNOC Onshore",
  },
];


const Testimonials = () => {
  return (
    <Wrapper>
      <Title>Words of praise from others about our presence.</Title>

      {/* Top Row */}
      <MarqueeContainer>
        <MarqueeContent>
          {testimonialsData.concat(testimonialsData).map((item, index) => (
            <Card key={`top-${index}`}>
              <FaQuoteLeft className="icon" />
              <p>{item.quote}</p>
              <h4>{item.name}</h4>
              <span>{item.role}</span>
            </Card>
          ))}
        </MarqueeContent>
      </MarqueeContainer>

      {/* Bottom Row with reverse animation */}
      <MarqueeContainer>
        <MarqueeContentReverse>
          {testimonialsData.concat(testimonialsData).map((item, index) => (
            <Card key={`bottom-${index}`}>
              <FaQuoteLeft className="icon" />
              <p>{item.quote}</p>
              <h4>{item.name}</h4>
              <span>{item.role}</span>
            </Card>
          ))}
        </MarqueeContentReverse>
      </MarqueeContainer>
    </Wrapper>
  );
};

export default Testimonials;

// Styled Components

const Wrapper = styled.section`
  padding: 60px 15px;
  background: ${(props) => props.theme.colors.extralight};
  text-align: center;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 80px 30px;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 30px;
  color: ${(props) => props.theme.colors.dark};

  @media (min-width: 768px) {
    font-size: 2rem;
    margin-bottom: 40px;
  }
`;

/* Keyframes for scrolling left */
const scrollLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

/* Keyframes for scrolling right */
const scrollRight = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

const MarqueeContainer = styled.div`
  overflow: hidden;
  width: 100%;
  margin-bottom: 30px;

  @media (min-width: 768px) {
    margin-bottom: 40px;
  }
`;

const MarqueeContent = styled.div`
  display: flex;
  width: fit-content;
  animation: ${scrollLeft} 30s linear infinite;
`;

const MarqueeContentReverse = styled(MarqueeContent)`
  animation: ${scrollRight} 30s linear infinite;
`;

const Card = styled.div`
  min-width: 250px;
  background: #fff;
  margin-right: 15px;
  padding: 18px 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  text-align: left;

  .icon {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.3rem;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.9rem;
    color: #444;
    margin-bottom: 10px;

    @media (min-width: 768px) {
      font-size: 0.95rem;
    }
  }

  h4 {
    font-size: 0.95rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.dark};
    margin: 0;
  }

  span {
    font-size: 0.8rem;
    color: #777;
  }

  @media (min-width: 768px) {
    min-width: 300px;
    margin-right: 20px;
    padding: 20px 25px;
    border-radius: 12px;

    .icon {
      font-size: 1.5rem;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 1rem;
    }

    span {
      font-size: 0.85rem;
    }
  }
`;
